import Text from "@/components/Text";
import { formatDate, formatTime } from "@/utils/date-time-utility";
import { ReportContainer } from "./constant";
import {
  ENCOUNTER_ADDENDUM_LABELS,
  ENCOUNTER_ADDENDUM_SIGNATURE_SIZE_PX,
} from "./encounter-addendum-constant";

export interface EncounterAddendumPrint {
  addendumText?: string | null;
  addendumSignedByName?: string | null;
  addendumSignedAt?: string | null;
  addendumSignature?: string | null;
}

export interface EncounterAddendumSectionProps {
  addendum?: EncounterAddendumPrint;
}

const NO_BREAK = { pageBreakInside: "avoid", breakInside: "avoid" } as const;

/** The signed addendum, printed below the original signature when the visit has one. */
const EncounterAddendumSection = ({
  addendum,
}: EncounterAddendumSectionProps) => {
  if (!addendum?.addendumText) return null;
  const { addedBy, on, at, placeholder } = ENCOUNTER_ADDENDUM_LABELS;
  const signedAt = addendum.addendumSignedAt;
  const date = formatDate(signedAt) ?? placeholder;
  const time = signedAt ? formatTime(signedAt) : placeholder;

  return (
    <ReportContainer label={ENCOUNTER_ADDENDUM_LABELS.section}>
      <div style={{ ...NO_BREAK, padding: "2px" }}>
        <Text style={{ whiteSpace: "pre-wrap" }}>{addendum.addendumText}</Text>
        <Text>{`${addedBy} ${
          addendum.addendumSignedByName ?? placeholder
        } ${on} ${date} ${at} ${time}`}</Text>
        {addendum.addendumSignature && (
          <img
            src={addendum.addendumSignature}
            alt={ENCOUNTER_ADDENDUM_LABELS.signatureAlt}
            width={ENCOUNTER_ADDENDUM_SIGNATURE_SIZE_PX}
            height={ENCOUNTER_ADDENDUM_SIGNATURE_SIZE_PX}
            style={{ ...NO_BREAK, display: "block", objectFit: "contain" }}
          />
        )}
      </div>
    </ReportContainer>
  );
};

export default EncounterAddendumSection;
